import { Wrap } from '@televet/kibble-ui/build/chakra';
import { Menu, MenuListProps } from '@televet/kibble-ui/build/components/Menu';
import { Tag, TagProps } from '@televet/kibble-ui/build/components/Tag';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';

interface TeletriageConversationCenterFilterRowProps extends MenuListProps {
  label: string;
  selectedItems: TagProps[];
}

export const TeletriageConversationCenterFilterRow = ({
  label,
  selectedItems,
  ...rest
}: TeletriageConversationCenterFilterRowProps): JSX.Element => {
  return (
    <Wrap px={3}>
      <Text as="p" fontWeight="semibold" size="sm">
        {label}:
      </Text>
      <Menu
        isLazy
        buttonProps={{ size: 'xs', variant: 'tertiary', leftIconName: 'plus', showRightIcon: false }}
        listProps={{ ...rest, isSearchable: true, isGrouped: true, isMultiSelect: true, canSelectGroups: true }}
      />
      {selectedItems?.map((selectedItem, index) => (
        <Tag
          key={`${label}-selected-item-${index}`}
          {...selectedItem}
          size="sm"
          closeButtonDisplay="always"
          bgColor="background.alpha"
        />
      ))}
    </Wrap>
  );
};
